var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.1,
    height: 46.1,
    fill: "#DFE3E8",
    rx: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.6 15h14.1v19.5H11.6zm15.9 0h14.2v17H27.5zm15.9-.4h14.2v18.7H43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40A648",
    d: "M46.2 26.7H50c.6 0 1.1-.7 1.1-1.4s-.5-1.3-1.1-1.4h-3.8v2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40A648",
    d: "M49.2 5.8a5.8 5.8 0 00-5.8 5.7v6h8.7c1.8 0 3.2 1 3.2 2.7 0 1.4-1.2 2.6-2.6 2.6 1.8.1 3.3 1.2 3.3 2.8 0 1.6-1.6 2.9-3.7 2.9h-9v11.8h8.5c3.2 0 5.8-2.6 5.8-5.7V5.8h-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40A648",
    d: "M50.7 20.6c0-.7-.4-1.3-1.2-1.4h-3.3v2.7h3.3c.7 0 1.2-.6 1.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D67B0",
    d: "M17.3 5.8a5.8 5.8 0 00-5.8 5.7v14.2c1.6.8 3.3 1.3 5 1.3a2.8 2.8 0 003-2.9v-6.6h5V24c0 2.6-1.6 4.8-7.1 4.8-2 0-4-.3-5.9-.8v12.2H20c3.2 0 5.7-2.6 5.7-5.7V5.8h-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE2034",
    d: "M33.3 5.8a5.8 5.8 0 00-5.8 5.7v7.6c1.4-1.3 4-2 8-1.9 1.6.1 3 .3 4.6.7v2.4a11 11 0 00-4.3-1.2c-3.1-.2-5 1.3-5 4 0 2.6 1.9 4.1 5 3.9 1.5-.1 3-.6 4.3-1.3v2.5c-1.5.3-3 .6-4.5.7-4.1.2-6.7-.6-8.1-1.9v13.3H36c3.2 0 5.8-2.6 5.8-5.7V5.8h-8.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.5f5d9fed36b094e7f152ae90a00aa0a2.svg";
export { ForwardRef as ReactComponent };